import { VerticalResults } from 'components/glampartners/VerticalResults';
import { HorizontalResults } from 'components/glampartners/HorizontalResults';

import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { Utils } from 'utils/Utils';
import { NavLink } from 'react-router-dom';
class InfluencerResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      results: null
    }
  }

  componentDidMount() {
    this.getAllResults();
  }

  getAllResults = () => {
    const getDate = new Date();
    const monthEnd = (getDate.getMonth() + 1).toString();
    const monthStart = (monthEnd - 4).toString();
    const year = getDate.getFullYear().toString();

    const limit = '?limit=900';
    const startPeriod = `startPeriod=${monthStart}%2F${year}`;
    const endPeriod = `endPeriod=${monthEnd}%2F${year}`;
    const token = this.props.token.Authorization;
    this.props.loaderShow();
    ExecuteRequest(
      GlamboxEndpoints.Partner.getAllResults,
      null,
      "GET",
      {
        Authorization: token
      },
      { endPeriod, limit, startPeriod },
      (response) => {
        let { result,
          statusCode } = response;
        
          console.log('aqui vai:',result,statusCode)

        if (statusCode === 200) {
          console.log('deu erro')
          console.log(response)
          this.setState({
            results: result.result
          });
        }
      }
    );

    ExecuteRequest(
      GlamboxEndpoints.Partner.getCampaignsResults,
      null,
      "GET",
      {Authorization: token},
      null,
      (response) => {
        console.log('AQUI MEMO', response);
      }
    );

    this.props.loaderHide();

  }

  renderResults = () => {
    const { mobile } = this.props.ui;
    const { results } = this.state;

    if (mobile) {
      const mobileObj = Utils.translateToVertical(results);
      console.log('mob')
      return (        
        <VerticalResults data={mobileObj} />
      );
    } else {
      const deskObj = Utils.translateToHorizontal(results);
      console.log('desk',deskObj)
      return (
        <HorizontalResults data={deskObj} />
      );
    }

  }

  render() {
    const { results } = this.state;
    if (!results) {
      return (
        <div className={"p-2 p-lg-5"}>
          <h1>Resultados</h1>
          <p>Carregando...</p>
        </div>
      );

    }

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners: Resultados</title>
        </Helmet>

        <h1>Resultados</h1>
        <div className={"p-2 p-lg-5"} style={{ background: "#fff", marginBottom: 30 }}>
        <center>O requisito mínimo para a transferência das comissões é de <strong>R$ 100</strong>. Caso você não tenha atingido esse valor no mês, a quantia será acumulada para os próximos meses.</center>
        <center>O seu pagamento será realizado sempre no dia 10 (ou próximo dia útil) do mês seguinte. Por isso, sempre mantenha seus <NavLink to={"/glampartner/dados-financeiros"}>dados para pagamentos </NavLink> atualizados.</center>
        </div>
        <div>
          {this.renderResults()}
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data,
  ui: state.ui,

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  }
  
});

InfluencerResults = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerResults);

export {
  InfluencerResults
};

